import { TransferMethodEnum, TransferPropertyInfoItem } from 'modules/Transfer/type';

export type TransferDetailStatus = 'Withdrawn' | 'Received' | 'Fail' | 'Processing' | 'Success';

export interface TransferDetailItem {
    broker: string;
    broker_id?: string; // 如果是Other经济上的时候, 这里是没有值的
    account_no: string;
    status: TransferDetailStatus;
    id: number;
    createdAt: number;
    company: string;
    broker_user_name: string;
    broker_account: string;
    file_urls?: string[];
    transfer_method: TransferMethodEnum;
    transfer_property_infos?: TransferPropertyInfoItem[];
    mktCashValue?: number; // 做多现金
    mktShortValue?: number; // 做空现金, 展示的时候需要转成负数
}
